import {Component, inject, ViewEncapsulation} from '@angular/core';
import {Button} from "primeng/button";
import {CardModule} from "primeng/card";
import {CheckboxModule} from "primeng/checkbox";
import {DialogModule} from "primeng/dialog";
import {DividerModule} from "primeng/divider";
import {DropdownModule} from "primeng/dropdown";
import {FormsModule} from "@angular/forms";
import {IconFieldModule} from "primeng/iconfield";
import {InputIconModule} from "primeng/inputicon";
import {InputSwitchModule} from "primeng/inputswitch";
import {InputTextModule} from "primeng/inputtext";
import {InputTextareaModule} from "primeng/inputtextarea";
import {PrimeTemplate} from "primeng/api";
import {TableLazyLoadEvent, TableModule} from "primeng/table";
import {Make} from "../../data/types/makes/types";
import {GroupsService} from "../../data/services/groups.service";
import {MakeService} from "../../data/services/make.service";
import {ImageService} from "../../data/services/image.service";
import {ImageDetail, Item} from "../../data/types/groups/types";
import {ImageModule} from "primeng/image";
import {RoundPipe} from "../../pipes/round.pipe";
import {DEFAULT_SELECTED_MAKE} from "../../const";

@Component({
    selector: 'app-jobs',
    standalone: true,
    imports: [
        Button,
        CardModule,
        CheckboxModule,
        DialogModule,
        DividerModule,
        DropdownModule,
        FormsModule,
        IconFieldModule,
        InputIconModule,
        InputSwitchModule,
        InputTextModule,
        InputTextareaModule,
        PrimeTemplate,
        TableModule,
        ImageModule,
        RoundPipe
    ],
    templateUrl: './jobs.component.html',
    styleUrl: './jobs.component.css',
    encapsulation: ViewEncapsulation.None
})
export class JobsComponent {
    groups: Make[] = [];

    defaultOptions = ['All', 'Yes', 'No']
    maxImagesOptions = [10, 25, 50, 100]

    groupsService = inject(GroupsService)
    makeService = inject(MakeService)
    imageService = inject(ImageService)

    makesLoading = true;
    imagesLoading = true;
    groupLoading = true;

    images: Item[] = []

    makes: Make[] = []
    selectedMake: Make | undefined = {name: 'Ford', id: 50, no_approved_images_groups_count: 0};
    selectedShowApprove: string = 'All';
    selectedShowGroups = true;
    groupName = ''
    selectedMaxImages = 50;
    totalRecords = 53;
    perPage = 10
    page = 1;
    pTableFirst = 0;

    constructor() {
        this.makeService.getMakes()
            .subscribe(value => {
                this.makes = value
                this.makesLoading = false
                for (const make of this.makes) {
                    if (make.id === DEFAULT_SELECTED_MAKE.id) {
                        this.selectedMake = make
                        break
                    }
                }
            })

        this.groupLoading = true;
        this.groupsService.getGroups().subscribe(value => {
            this.groups = value
            this.groupLoading = false
        })
    }

    getParams() {
        let makeId = -1;
        if (this.selectedMake) {
            makeId = this.selectedMake.id;
        }

        if (!(this.selectedShowApprove === 'Yes')) {
            this.selectedShowApprove = ''
        } else if (this.selectedShowApprove === 'Yes') {
            this.selectedShowApprove = 'true'
        }

        return {
            approved: this.selectedShowApprove,
            image_limit: this.selectedMaxImages,
            per_page: this.perPage,
            page: this.page,
            sjc_name: this.groupName,
            make_id: makeId,
        }
    }

    loadImages($event: TableLazyLoadEvent = {}) {
        this.perPage = $event.rows || 10;
        this.page = 1;
        this.pTableFirst = 0;

        if ($event.first && $event.rows) {
            this.page = ($event.first / $event.rows) + 1
            this.pTableFirst = $event.first;
        }

        this.imagesLoading = true;
        this.groupsService.getImages(this.getParams(), 'jobs')
            .subscribe(value => {
                this.images = value.items
                this.imagesLoading = false
                this.totalRecords = value.total_pages * this.perPage
            })
    }

    onChangeCheckbox(image: ImageDetail, $event: any): void {
        return this.imageService.approveJobs(image, $event.checked, this.selectedMake?.id!)
    }
}
